import { render, staticRenderFns } from "./BFooter.vue?vue&type=template&id=3e072f41&scoped=true"
import script from "./BFooter.vue?vue&type=script&lang=js"
export * from "./BFooter.vue?vue&type=script&lang=js"
import style0 from "./BFooter.vue?vue&type=style&index=0&id=3e072f41&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e072f41",
  null
  
)

export default component.exports